import { toastError } from '../../../commons/utils';
import { SlotProps } from '../../Gallery';
import { FileProps } from "../../../s3/aws";
import { IContext } from "../../../contexts/AuthProvider/types";

export function getNewStatus(status: any, idAtual: any, next: boolean) {
    const statusAtual = status.find((item: any) => item.id === idAtual);

    const candidatos = status.filter((item: any) => item.rejeitado === 0 && (next ? item.sequencia > statusAtual.sequencia : item.sequencia < statusAtual.sequencia));

    const statusAdjacente = candidatos.reduce((adjacente: any, atual: any) =>
        (!adjacente || (next ? atual.sequencia < adjacente.sequencia : atual.sequencia > adjacente.sequencia)) ? atual : adjacente, null
    );

    return statusAdjacente ? statusAdjacente.id : null;
}

export async function updateStatus(auth: any, status: any, data: any, next: boolean) {
    data.colstatusid = getNewStatus(status, data.colstatusid, next);

    await auth.post('/v1/colaboradorstatuscrm', { colstatusid: data.colstatusid }, { colid: data.colid })
        .then(() => {

        })
        .catch((error: any) => {
            console.log(error)
        })
}

export async function confirmDesistencia(auth: any, coldesid: string, colid: string) {
    await auth.post('/v1/colaboradordesistenciaconfirm', { coldesid, colid, coldessituacao: 1, usucodigoaprovacao: auth.usucodigo, coldesdatahoraconfirmacao: new Date() })
        .then(() => {

        })
        .catch((error: any) => {
            toastError(error)
        })
}

export async function getFiles(auth: any, colid: string): Promise<SlotProps[]> {
    try {
        const response: any = await auth.get('/v1/colaboradorarquivocolaborador?colid=' + colid + '&colarqativo=1');

        if (response?.data) {
            const slots: SlotProps[] = response.data.filter((e: any) => e._delete !== 1).map((item: any) => ({
                ...item,
                uuid: item.colarqid,
                url: item.colarqurl,
                type: item.colarqurl.toLowerCase().endsWith(".pdf") ? 'document' : 'image',
                name: item.colarqtipo
            }));

            return slots;
        } else
            return [];
    } catch (error: any) {
        toastError(`Erro ao carregar arquivos: ${error.message || error}`);
        return [];
    }
}

export async function deleteFileColaborador(auth: IContext, colid: any, file: any) {
    const body = {
        ...file,
        _delete: 1
    };

    try {
        await auth.deleteRequest('/v1/colaboradorarquivo', body);
    } catch (error: any) {
        toastError(error);
    }
}

export async function uploadFileColaborador(auth: IContext, colid: string, file: FileProps) {
    const body = {
        colarqid: file.uuid,
        colid,
        colarqtipo: file.filename || 'Geral',
        colarqurl: file.url
    };

    try {
        const retorno: any = await auth.post('/v1/colaboradorarquivoone', body);
        return { ...retorno.data, uuid: retorno.data.colarqid }
    } catch (error: any) {
        toastError(error);
    }
}